/**
 |--------------------------------------------------------------------------
 | ACTIVITY : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const admin = [
 {
  path: '/admin/scheduler', component: require('pages/admin/scheduler.vue').default,
  name: '/admin/scheduler',
  meta: {requiresAuth: true, title: "Scheduler", icon: "fas fa-clock"}
 },
];
export default admin;
